import { createSelector } from 'reselect';

const townsSelectionFunction = state => state.view.nearestGroup?.towns;
export const townsSelector = createSelector([townsSelectionFunction], towns => towns);

const tempGroupSelectorFunc = state => state.view.nearestGroup?.searchResults;
const tempGroupSelector = createSelector([tempGroupSelectorFunc], countyCyGroup => countyCyGroup);

export default tempGroupSelector;
